var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 11.3C19.3 10.9 18.7 10.9 18.3 11.3L13 16.6V5C13 4.4 12.6 4 12 4C11.4 4 11 4.4 11 5V16.6L5.7 11.3C5.3 10.9 4.7 10.9 4.3 11.3C3.9 11.7 3.9 12.3 4.3 12.7L11.3 19.7C11.4 19.8 11.5 19.9 11.6 19.9C11.7 20 11.9 20 12 20C12.1 20 12.3 20 12.4 19.9C12.5 19.8 12.6 19.8 12.7 19.7L19.7 12.7C20.1 12.3 20.1 11.7 19.7 11.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowDown.3f7f85ee11d70ca2658cd54aeb565044.svg";